import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  HorizontalPillsConfig,
  HorizontalPillsConfigItem,
  HorizontalPillsConfigItemType,
} from './horizontalpills.interface';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-horizontalpills',
  templateUrl: './horizontalpills.component.html',
  imports: [NgClass],
})
export class HorizontalPillsComponent {
  private readonly router = inject(Router);

  @Input() config: HorizontalPillsConfig = {
    items: [],
  };

  @Output() itemclick = new EventEmitter<HorizontalPillsConfigItem>();

  itemclicked(menuItem: HorizontalPillsConfigItem) {
    if (menuItem.type === HorizontalPillsConfigItemType.Callback) {
      this.itemclick.emit(menuItem);
    } else if (menuItem.type === HorizontalPillsConfigItemType.Path) {
      this.router.navigate([menuItem.id]);
    }
  }
}
